module.exports = __webpack_public_path__ + "img/lb10.d34cbf9a.svg";